import { render, staticRenderFns } from "./TelecomEditor.vue?vue&type=template&id=3b66c34c&scoped=true&"
import script from "./TelecomEditor.vue?vue&type=script&lang=js&"
export * from "./TelecomEditor.vue?vue&type=script&lang=js&"
import style0 from "./TelecomEditor.vue?vue&type=style&index=0&id=3b66c34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66c34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
